module.exports = "$(\"#select_all\").click(function(){$(\"#locations option\").prop(\"selected\",!0)});"